









import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import Pill from "@/shared/components/ui/Pill.vue";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap
} from "@/shared/types";

@Component({
  components: {
    Pill
  }
})
export default class HsabExpenseReimbursementStatusPill extends Vue {

  @Prop({ required: true })
  status: CombinedClaimReceiptStatus;

  get showStatusPill () {
    return this.status !== CombinedClaimReceiptStatus.None;
  }

  get pillType () {
    switch (this.status) {
      case CombinedClaimReceiptStatus.Paid:
      case CombinedClaimReceiptStatus.MarkedAsPaid:
        return "green-bg";
      case CombinedClaimReceiptStatus.ReceiptNeeded:
      case CombinedClaimReceiptStatus.NewReceiptNeeded:
      case CombinedClaimReceiptStatus.ReceiptOverdue:
        return "red-bg";
    }
    return "grey-bg";
  }

  get displayText () {
    return CombinedClaimReceiptStatusMap[this.status];
  }
}
